/**
 * The server redirects to `/?signin=<reason>` after a failed, cancelled, or
 * blocked sign-in. This maps that query param to the friendly copy shown on
 * the landing page. Unknown or absent values show nothing.
 */
export type SigninMessageParam = 'cancelled' | 'failed' | 'not-in-clan' | 'removed' | 'rejected';

const MESSAGES: Record<SigninMessageParam, string> = {
  cancelled: 'Sign-in was cancelled.',
  failed: 'Sign-in failed. Please try again.',
  'not-in-clan': "Sign-in is limited to members of the clan's Discord server.",
  removed: "You're no longer on the crew's roster. Ask an officer if this is a mistake.",
  rejected: 'Your request to join the crew was declined.',
};

export function signinMessageFor(param: string | null): string | null {
  if (param === null) return null;
  if (
    param === 'cancelled' ||
    param === 'failed' ||
    param === 'not-in-clan' ||
    param === 'removed' ||
    param === 'rejected'
  ) {
    return MESSAGES[param];
  }
  return null;
}
